import React from 'react';
import { Alert, Spinner, Table } from 'react-bootstrap';
import type { ExportPreviewResponse } from './api';

interface Props {
  preview: ExportPreviewResponse | null;
  loading: boolean;
  error?: string | null;
}

const ExportPreview: React.FC<Props> = ({ preview, loading, error }) => {
  if (loading) {
    return (
      <div className="text-muted py-3">
        <Spinner animation="border" size="sm" className="me-2" />
        Gerando prévia com o mesmo motor do arquivo...
      </div>
    );
  }
  if (error) {
    return <Alert variant="danger">{error}</Alert>;
  }
  if (!preview) {
    return <p className="text-muted mb-0">Aplique os filtros para ver uma amostra dos registros e colunas resolvidas.</p>;
  }
  if (preview.total === 0) {
    return <p className="text-muted mb-0">Nenhum registro encontrado com os filtros aplicados.</p>;
  }

  const previewColumns = preview.columns.slice(0, 6);

  return (
    <div>
      <div className="d-flex flex-wrap gap-3 small text-muted mb-2">
        <span>Total: {preview.total}</span>
        {preview.subtask_count > 0 && <span>Subtarefas: {preview.subtask_count}</span>}
        <span>Colunas: {preview.columns.length}</span>
        {preview.truncated && <span>Recorte limitado ao máximo configurado.</span>}
      </div>
      {preview.diagnostics.length > 0 && (
        <Alert variant="warning" className="py-2">
          {preview.diagnostics.slice(0, 3).map((item, index) => (
            <div key={`${item.code}-${index}`}>{item.message}</div>
          ))}
        </Alert>
      )}
      <div className="table-responsive">
        <Table size="sm" bordered hover className="dashboard-table export-preview-table mb-0">
          <thead>
            <tr>
              <th>ID</th>
              <th>Título</th>
              <th>Status</th>
              <th>Fluxo</th>
              {previewColumns.map((column) => (
                <th key={column.field_id}>{column.header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {preview.rows.map((row) => (
              <tr key={row.record_id}>
                <td>{row.public_id}</td>
                <td>{row.title}</td>
                <td>{row.status}</td>
                <td>{row.workflow_name}</td>
                {previewColumns.map((column) => {
                  const value = row.cells[String(column.field_id)] || '';
                  const residual = value === 'Não se aplica';
                  return (
                    <td
                      key={`${row.record_id}-${column.field_id}`}
                      className={residual ? 'export-residual' : undefined}
                    >
                      {value}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default ExportPreview;
